export const createAddonTitle = (a) => {
  let visibleTitle = a.title;
  let visibleOption = a.option;

  if (a?.addons_data?.titleOnPrint) {
    visibleTitle = a.addons_data.titleOnPrint;
  }

  if (a?.addons_data?.hideTitleOnPrint || a?.hide_title_on_print) {
    visibleTitle = a.option;
    visibleOption = undefined;
  }

  let prefix = "";
  if (a?.addons_data?.optiontype === "multiselectno") {
    prefix = "UTEN ";
  }
  //   if (a?.addons_data?.optiontype === "multiselectyes") {
  //     prefix = "MED ";
  //   }

  if (!visibleOption || visibleTitle === visibleOption) {
    return `${prefix}${visibleTitle}`;
  } else {
    return `${prefix}${visibleTitle}: ${visibleOption}`;
  }
};
